export enum InPageMessagingType {
	'discovery' = 'discovery',
	'error' = 'error',
	'info' = 'info',
	'neutral' = 'neutral',
	'success' = 'success',
	'warning' = 'warning',
}
